import PropTypes from 'prop-types';
import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const Video = ({ theme: themeKey = 'base' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="1.16667" width="10.5" height="10.5" fill={theme[themeKey]} />
    <path
      d="M9.33325 6.41666L13.9999 2.33333V10.5L9.33325 6.41666Z"
      fill={theme[themeKey]}
    />
  </svg>
);

Video.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction', 'interactionDark'])
};

export default Video;
